// extracted by mini-css-extract-plugin
export default {"contentBlocks":"contentBlocks___ywOLt","textLowercase":"textLowercase___uM2em"};